import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "../pages/Login";
import DefaultPage from "../pages/DefaultPage";
import ProtectedRoute from "./ProtectedRoute";
import Root from "../pages/Root";
import AddPcard from "../pages/AddPcard";
import Pcards from "../pages/Pcards";
import UserCard from "../pages/UserCard";
import Home from "../pages/Home";
import AddGcard from "../pages/AddGcard";
import Gcards from "../pages/Gcards";
import EditPcard from "../pages/EditPcard";
import EditGcard from "../pages/EditGcard";
import NewBussinesCard from "../pages/NewBussinesCard";


const AppRoute = () => {
  return (
    <>
      <Routes>
        <Route path="user/login" exact element={<Login />} />
        <Route path="/card/bussines"  exact element={<UserCard/>} />
        <Route element={<ProtectedRoute />}>
          <Route path="/" element={<Root />}>
          <Route index exact element={<Home/>} />
            <Route path="/addpcard"  exact element={<AddPcard />} />
            <Route path="/pcard/edit"  exact element={<EditPcard />} />
            <Route path="/addgcard"  exact element={<AddGcard />} />
            <Route path="/gcard/edit"  exact element={<EditGcard />} />
            <Route path="/pcards"  exact element={<Pcards/>} />
            <Route path="/gcards"  exact element={<Gcards/>} />
            <Route path="/newbussinescard"  exact element={<NewBussinesCard />} />
          </Route>
            <Route path="*" exact element={<DefaultPage />} />
        </Route>
      </Routes>
    </>
  );
};

export default AppRoute;
